import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "rounded-lg border border-gray-200 bg-white p-4"
}
const _hoisted_2 = { class: "text-[10px] font-bold uppercase tracking-[0.5px] text-gray-400" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "mt-1 flex min-h-10 items-center" }
const _hoisted_5 = {
  key: 1,
  class: "text-xs italic text-gray-400"
}
const _hoisted_6 = {
  key: 2,
  class: "line-clamp-2 text-sm leading-5 text-gray-700"
}

import { computed } from 'vue';
import Spinner from '@/components/ui/Spinner.vue';
import { useSectionCameras, type SectionCamerasRequest } from '@/plugins/store/actions/queries/production-groups';
import { cameraLabel } from './cameraIdentity';

// Read-only list of the cameras mounted on a Section, as of the start date currently entered in the
// manage-Production Group form. Owns its own read: the date it displays for is the only input it needs,
// and nothing here feeds back into the form.

export default /*@__PURE__*/_defineComponent({
  __name: 'SectionCamerasReadout',
  props: {
    sectionId: {},
    date: {}
  },
  setup(__props: any) {

const props = __props;

const request = computed<SectionCamerasRequest | null>(() => (props.sectionId !== null && props.date ? { sectionId: props.sectionId, date: props.date } : null));

const { data, isPending } = useSectionCameras(request);

const cameras = computed(() => data.value ?? []);
// Through the shared label rather than the raw name: a Sensor with no name of its own would
// otherwise contribute an empty string to the join and read as a missing entry between two commas,
// so the label falls back to the camera's position in this list. That position is this list's own -
// resolved as of one calendar date - so an unnamed camera's label here need not match the one a
// chart gives it over a longer window (see cameraSeries.ts).
const cameraNames = computed(() => cameras.value.map((camera, index) => cameraLabel(camera, index)).join(', '));

return (_ctx: any,_cache: any) => {
  return (request.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h3", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.$t('views.monitoring.productionGroups.modals.manageProductionGroup.cameras.title')) + " ", 1),
          (cameras.value.length)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(cameras.value.length) + ")", 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_unref(isPending))
            ? (_openBlock(), _createBlock(Spinner, {
                key: 0,
                class: "h-4 w-4"
              }))
            : (!cameras.value.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.$t('views.monitoring.productionGroups.modals.manageProductionGroup.cameras.empty')), 1))
              : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(cameraNames.value), 1))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})